import { createFormAction } from "redux-form-saga";
export const ROLE_FORM_KEY = "ROLE_FORM_KEY";
export const RoleFormAction = createFormAction(ROLE_FORM_KEY);

export const USER_FORM_KEY = "USER_ROLE_FORM_KEY";
export const UserFormAction = createFormAction(USER_FORM_KEY);

